import type { Option } from 'src/types/formFields';

export const getOptionText = (options: Option[], value: string) =>
  options.find((o) => o.value === value)?.text;
